import { useTranslation } from '@/i18n';
import { IconCaution, Tag } from '@moneyforward/ap-frontend-components';
import { Tooltip } from 'antd';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './AiSuggestSummaryBanner.module.scss';

const cx = classnames.bind(styles);

/**
 * AI Suggest failure alert label shown above 基本情報 when the AI Suggest process
 * failed. Hovering the label reveals a tooltip explaining the failure.
 */
const InnerAiSuggestFailureLabel: FC = () => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('received_invoice.ai_suggest_tooltip_failed')}>
      <span className={cx('failure')}>
        <Tag
          status='warning'
          closable={false}
          outline={false}
          size='default'
          customIcon={<IconCaution size={12} />}
        >
          {t('received_invoice.ai_suggest_label')}
        </Tag>
      </span>
    </Tooltip>
  );
};

InnerAiSuggestFailureLabel.displayName = 'InnerAiSuggestFailureLabel';

export const AiSuggestFailureLabel: FC = memo(InnerAiSuggestFailureLabel);
AiSuggestFailureLabel.displayName = 'AiSuggestFailureLabel';
